import { FC, useEffect } from "react"

const PageTitle: FC<{ title: string }> = ({ title }) => {
    useEffect(() => {
        document.title = title
    }, [title])
    return null
}

export default PageTitle